import { render, staticRenderFns } from "./LectureContentSidebar.vue?vue&type=template&id=91a71380&scoped=true&"
import script from "./LectureContentSidebar.vue?vue&type=script&lang=js&"
export * from "./LectureContentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LectureContentSidebar.vue?vue&type=style&index=0&id=91a71380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a71380",
  null
  
)

export default component.exports